<div class="mx-2 mt-2 pb-3 search">
  <div class="d-flex justify-content-between mb-2">
    <h3>Panel Catalog</h3>
    <button
      nf-icon-button="secondary"
      icon="close"
      class="btn-bare close"
      ngbTooltip="Close Panel Catalog"
      (click)="closePanel.emit()"
    >
      Close Panel Catalog
    </button>
  </div>

  <nf-search
    placeholder="Search Panel Catalog"
    [formControl]="panelSearch"
    autofocus
  >
  </nf-search>
</div>
<div class="panel-section">
  <div *ngFor="let category of panelsByCategory | keyvalue: returnZero">
    <div
      *ngIf="category.value.hasVisiblePanels"
      class="category"
      (click)="toggleCategory(category.key)"
    >
      <h4 class="ml-2">{{ category.key }}</h4>
      <button
        *ngIf="!category.value.expanded"
        nf-icon-button="secondary"
        icon="chevron-right"
        class="btn-bare"
        ngbTooltip="Expand Category"
      >
        Expand {{ category.key }} Category
      </button>
      <button
        *ngIf="category.value.expanded"
        nf-icon-button="secondary"
        icon="chevron-down"
        class="btn-bare"
        ngbTooltip="Collapse Category"
      >
        Collapse {{ category.key }} Category
      </button>
    </div>
    <div>
      <ng-container *ngFor="let panelMetadata of category.value.panels">
        <hs-panel-card
          [ngClass]="{
            'd-none': !category.value.expanded || !panelMetadata.isVisible
          }"
          [panelMetadata]="panelMetadata"
          [layoutManager]="layoutManager"
        >
        </hs-panel-card>
      </ng-container>
    </div>
  </div>
</div>
